import { Card } from 'react-bootstrap'
import classnames from 'classnames'
import React, { FC } from 'react'

export interface ProductCardProps {
  active: boolean
  amountInDollars: string
  interval: string
  onClick: (id: string) => void
  priceId: string
  title: string
}

export const ProductCard: FC<ProductCardProps> = ({
  active,
  amountInDollars,
  interval,
  onClick,
  priceId,
  title,
}) => {
  const cardClasses = classnames('product-card-body', {
    'product-card-body--active': active,
  })
  const cardTextClasses = classnames('product-card-text', {
    'product-card-text--active': active,
  })
  const radioClass = classnames('radio-input')
  const handleClick = (id: string) => () => onClick(id)

  return (
    <label htmlFor={priceId} onClick={handleClick(priceId)}>
      <Card className={cardClasses}>
        <Card.Header className="product-card-header">{title}</Card.Header>
        <Card.Body>
          <Card.Text className={cardTextClasses}>
            ${amountInDollars}
            <span>/{interval}</span>
          </Card.Text>
        </Card.Body>
        <input
          id={priceId}
          className={radioClass}
          name="product"
          readOnly
          type="radio"
          value={priceId}
        />
      </Card>
    </label>
  )
}
